import { environment } from '../../../environments/environment';

const UTM_SOURCE = 'booking_portal';
const UTM_CAMPAIGN = 'manager_acquisition';

/** Rotta pubblica del PMS: la root redirige comunque qui passando dall'AuthGuard. */
export const PMS_SIGN_IN_PATH = '/sign-in';

/** Un medium UTM per ogni punto di ingresso verso il PMS. */
export type PmsUtmMedium = 'header_btn' | 'footer_link';

/** Distingue la posizione della CTA a parità di medium (GA4: utm_content, non utm_medium). */
export type PmsUtmContent = 'header' | 'footer';

/**
 * Costruisce l'URL verso il PMS gestori con parametri UTM per il tracciamento
 * dei lead generati dal portale prenotazioni (booking-web).
 */
export function buildPmsUrl(
  path: string,
  medium: PmsUtmMedium,
  content: PmsUtmContent,
): string {
  const url = new URL(path, environment.pmsWebsiteUrl);
  url.searchParams.set('utm_source', UTM_SOURCE);
  url.searchParams.set('utm_medium', medium);
  url.searchParams.set('utm_campaign', UTM_CAMPAIGN);
  url.searchParams.set('utm_content', content);
  return url.toString();
}
